import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { z } from 'zod'
import { OAuthErrorScreen } from '@/features/mcp/routes/oauth-error-screen'
import { pageTitle } from '@/lib/brand'

/**
 * Where connecting an AI app lands when it goes wrong (docs/MCP.md). Public:
 * the person may not be signed in. `reason` is ours; `error` is the code
 * Better Auth's provider adds to its error address (`onAPIError.errorURL`).
 */
export const Route = createFileRoute('/oauth/error')({
  validateSearch: z.looseObject({
    reason: z.string().max(40).optional(),
    error: z.string().max(80).optional(),
  }),
  component: OAuthError,
})

function OAuthError() {
  useEffect(() => {
    document.title = pageTitle('Couldn’t connect')
  }, [])
  return <OAuthErrorScreen />
}
